module.exports = __webpack_public_path__ + "svg_80x80/ruby.8c741d.svg";